import { useEffect, useState } from 'react';
import { useCart } from '../../context/CartProvider';
import DrawerSelect from '../ui/DrawerSelect';
import ImageWithFallback from '../ui/ImageWithFallback';
import EMAILICON from '../../../images/mail-outline.svg';

const {
    labelOrderNow,
    lang_material_variant,
    lang_material_quantity,
    lang_material_size,
    lang_add_to_cart,
    lang_added_to_cart,
    lang_cart_heading_title,
    is_cart_limit_applicable_active_flag,
    lang_cart_limit,
    is_add_and_checkout_active_flag,
    is_email_icon_active,
    lang_email_subject,
    template_directory_uri
} = window.ordering_cart_script_checkout;

const DetailDrawer = () => {
    const { cartItemData, addtoMulticartlimitflag, isproductAdded, setIsproductAdded } = useCart()
    const [formData, setFormData] = useState({
        order_size: "",
        order_variant: "",
        order_quantity: ""
    })

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }

    // Reset form item data
    const resetData = () => {
        if (cartItemData && Object.keys(cartItemData).length > 0) {
            setFormData({
                order_size: cartItemData.material_size[0],
                order_variant: cartItemData.material_variant[0],
                order_quantity: cartItemData.product_quantity[0]
            })
        }
    }

    useEffect(() => {
        setTimeout(resetData, 1500);
    }, [cartItemData])

    /**
     * Effect to handle the offcanvas drawer close event.
     *  This effect sets up an event listener for the offcanvas drawer close event,
     */
    useEffect(() => {
        const offcanvasElement = document.getElementById("cartFormffReact");
        if (!offcanvasElement) return;
        const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement) || new bootstrap.Offcanvas(offcanvasElement);
        const handleDrawerClose = () => {
            setIsproductAdded(false)
            resetData();
        };
        offcanvasElement.addEventListener("hidden.bs.offcanvas", handleDrawerClose);
        return () => {
            offcanvasElement.removeEventListener("hidden.bs.offcanvas", handleDrawerClose);
        };
    }, []);

    return (
        <div className="offcanvas offcanvas-end" id="cartFormffReact">
            <div className="offcanvas-header" style={{ padding: '2.4rem 2.9rem 0.4rem' }}>
                <h3 className="offcanvas-title">{lang_cart_heading_title}</h3>
                <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="closeButtonCartSetting"></button>
            </div>
            <div className="offcanvas-body">
                <div id="cartFormBody" className="mt-0 mx-4">
                    <div className="row align-items-center">
                        <div className="cartproductIMG col-3">
                            {
                                cartItemData?.material_image ? <ImageWithFallback src={cartItemData?.material_image} alt={cartItemData?.post_title} fallback={`${template_directory_uri}/assets/images/no_preview.png`} className={'img-fluid'} /> : <ImageWithFallback src={`${template_directory_uri}/assets/images/no_preview.png`} alt={cartItemData?.post_title} className={'img-fluid'} />
                            }
                        </div>
                        <div className="cartproductBox nopadding col-9">
                            <div className="cartproductTitle"> {cartItemData.post_title}</div>
                            <div className="shortContentDesc">{cartItemData.product_short_description}</div>
                        </div>
                    </div>
                    {
                        cartItemData.is_long_description && <div className="form-group mb-3">
                            <div className="longContentDesc">{cartItemData.material_long_description}</div>
                        </div>
                    }
                    {
                        cartItemData?.is_material_size && <DrawerSelect id="order_size" label={lang_material_size} name="order_size" value={formData.order_size} data={cartItemData.material_size} onChange={handleChange} />
                    }
                    {
                        cartItemData?.is_material_variant && <DrawerSelect id="order_variant" label={lang_material_variant} name="order_variant" value={formData.order_variant} data={cartItemData.material_variant} onChange={handleChange} />
                    }
                    {
                        cartItemData?.product_quantity?.length > 0 && <DrawerSelect id="order_quantity" label={lang_material_quantity} name="order_quantity" value={formData.order_quantity} data={cartItemData.product_quantity} onChange={handleChange} />
                    }
                    <div className="form-group">
                        <div className="col hrline"></div>
                    </div>
                    <div className="form-group mt-2 mb-5">
                        {is_add_and_checkout_active_flag === "1" ? (
                            <div className="footerButtons ischeckoutenable">
                                {is_cart_limit_applicable_active_flag === '1' ? (
                                    <>
                                        {
                                            isproductAdded ? <button type='button' disabled className='btn col addtocart addtocartButtonSuccess'>{lang_added_to_cart}</button> : <>
                                                <button type='button' className={`btn col addtocart btn-smoke addtocartButton`} onClick={() => addtoMulticartlimitflag({ ...cartItemData, ...formData }, true, lang_cart_limit, false)}
                                                >
                                                    {isproductAdded ? lang_added_to_cart : lang_add_to_cart}
                                                </button>
                                                <button type='button'
                                                    className="btn btn-smoke addandcheckoutButton col limitflag" onClick={() => addtoMulticartlimitflag({ ...cartItemData, ...formData }, true, lang_cart_limit, true)}
                                                >
                                                    {labelOrderNow}
                                                </button>
                                            </>
                                        }

                                    </>
                                ) : (
                                    <>
                                        {
                                            isproductAdded ? <button type='button' disabled className='btn col addtocart addtocartButtonSuccess'>{lang_added_to_cart}</button> : <>
                                                <button type='button'
                                                    className="btn btn-smoke addtocartButton col" onClick={() => addtoMulticartlimitflag({ ...cartItemData, ...formData }, false, 0, false)}
                                                >
                                                    {isproductAdded ? lang_added_to_cart : lang_add_to_cart}
                                                </button>
                                                <button type='button'
                                                    className="btn btn-smoke addandcheckoutButton col" onClick={() => addtoMulticartlimitflag({ ...cartItemData, ...formData }, false, null, true)}
                                                >
                                                    {labelOrderNow}
                                                </button>
                                            </>
                                        }

                                    </>
                                )}
                                <div className="footerIcons ml-5">
                                    {is_email_icon_active && (<>
                                        <div onClick={() => window.open(lang_email_subject, '_blank')} style={{ marginLeft: '1rem', cursor: 'pointer' }}>
                                            <img src={EMAILICON} alt="Email" width={15} height={'auto'} />
                                        </div>
                                    </>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="footerButtons">
                                    {is_cart_limit_applicable_active_flag === '1' ? (
                                        <button type='button' className={`btn col addtocart ${isproductAdded ? 'addtocartButtonSuccess' : 'btn-smoke addtocartButton'}`} disabled={isproductAdded} onClick={() => addtoMulticartlimitflag({ ...cartItemData, ...formData }, true, lang_cart_limit, false)}
                                        >
                                            {isproductAdded ? lang_added_to_cart : lang_add_to_cart}
                                        </button>
                                    ) : (
                                        <button type='button' className={`btn col addtocart ${isproductAdded ? 'addtocartButtonSuccess' : 'btn-smoke addtocartButton'}`} disabled={isproductAdded} onClick={() => addtoMulticartlimitflag({ ...cartItemData, ...formData }, false, 0, false)}
                                        >
                                            {isproductAdded ? lang_added_to_cart : lang_add_to_cart}
                                        </button>
                                    )}
                                </div>
                                <div className="footerIcons ml-5">
                                    {is_email_icon_active && (
                                        <div onClick={() => window.open(lang_email_subject, '_blank')} style={{ marginLeft: '1rem', cursor: 'pointer' }}>
                                            <img src={EMAILICON} alt="Email" width={15} height={'auto'} />
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>


                </div>
            </div>
        </div>
    )
}

export default DetailDrawer